import { Controller } from "@hotwired/stimulus"

// Pure Tailwind modal controller - no Bootstrap dependencies
export default class extends Controller {
  static targets = ["overlay"]

  connect() {
    // Set up ESC key listener for modal closing
    this.keyDownHandler = this.handleKeyDown.bind(this)
    document.addEventListener("keydown", this.keyDownHandler)

    // Store original body overflow
    this.originalOverflow = document.body.style.overflow

    // Hide modal on initial load
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("hidden")
    }
  }

  disconnect() {
    // Remove event listener
    document.removeEventListener("keydown", this.keyDownHandler)

    // Restore body overflow
    document.body.style.overflow = this.originalOverflow
  }

  open(event) {
    if (event) event.preventDefault()

    if (this.hasOverlayTarget) {
      // Show the modal
      this.overlayTarget.classList.remove("hidden")
      this.overlayTarget.classList.add("flex")

      // Prevent body scrolling
      document.body.style.overflow = "hidden"

      // Focus the first focusable element
      setTimeout(() => {
        const focusable = this.overlayTarget.querySelector(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )
        if (focusable) {
          focusable.focus()
        }
      }, 50)
    }
  }

  close(event) {
    if (event) event.preventDefault()

    if (this.hasOverlayTarget) {
      // Hide the modal
      this.overlayTarget.classList.add("hidden")
      this.overlayTarget.classList.remove("flex")

      // Restore body scrolling
      document.body.style.overflow = this.originalOverflow
    }
  }

  handleKeyDown(event) {
    // Close modal on ESC key
    if (event.key === "Escape" && this.isOpen()) {
      this.close()
    }
  }

  // Handle clicks on the modal container
  handleContainerClick(event) {
    // Prevent clicks within the container from closing the modal
    event.stopPropagation()
  }

  isOpen() {
    return this.hasOverlayTarget && !this.overlayTarget.classList.contains("hidden")
  }
}